import { render, staticRenderFns } from "./beca-registro.vue?vue&type=template&id=70103024&"
import script from "./beca-registro.component.ts?vue&type=script&lang=ts&"
export * from "./beca-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports